export default function filterUnique<T extends { value: string | number }>(values: T[]): T[] {
  return [...new Map(values.map(item => [item.value, item])).values()];
}
